export default __webpack_public_path__ + "static/media/ProgressStage1.5432fe87.svg";